import React from "react";
import { Button } from "./Button";

export const AddAndCloseButton = ({ onClick, disabled, text = "" }) => {
  return (
    <Button
      style={{ backgroundColor: "lightgreen" }}
      disabled={disabled}
      onClick={onClick}
    >
      {text || "➕"}
    </Button>
  );
};
